import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=3a70b75c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=3a70b75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70b75c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a70b75c')) {
      api.createRecord('3a70b75c', component.options)
    } else {
      api.reload('3a70b75c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=3a70b75c&scoped=true&", function () {
      api.rerender('3a70b75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oTD4RQ9Q1UWQ/JS/comp/GuestBox.vue"
export default component.exports